define('boxes/controllers/signup-controller',['jquery', 'boxes/controllers/box-controller', 'boxes/signup-account', 'boxes/signup-detail', 'boxes/events/signUpEvent', 'boxes/events/paymentEvent', 'all/slider', 'boxes/deposit-bonus/deposit-bonus-box', 'boxes/email-verification-box', 'boxes/mobile-verification-box', 'boxes/deposit-box', 'boxes/deposit-result-box', 'payment/getPaymentResult', 'boxes/events/controller-event'], function ($, boxController, signUpAccount, signUpDetail, signUpEvent, paymentEvent, slider, depositBonusBox, emailVerificationBox, mobileVerificationBox, depositBox, depositResultBox, getPaymentResult, controllerEvent) {
    'use strict';
    var controller = boxController.create();

    function start(boxControllerSelector) {
        controller.setSelector(boxControllerSelector);
        controller.start(setup);
        getPaymentResult.start(controller);
        return controller;
    }

    function setupControllerEventHandlers() {
        controller.on(signUpEvent.SLIDE_ICON, function () {
            slider.slideIcon();
        });
        controller.on(signUpEvent.REGISTER_SUCCESS, function () {
            getPixelTrackingData();
        });

        controller.on(controllerEvent.RESET, function () {
            reset();
        });
    }

    function reset() {
        controller.find('.steps .step').removeClass('done animate');
        controller.find('.steps .step:not(:first-child)').removeClass('active');
        controller.find('.steps .step').first().addClass('active');
		controller.find('#gender-id').children().removeClass('active');
		controller.find('select[name=PARAM_YEAR]').val(0);
		controller.find('select[name=PARAM_MONTH]').val(0);
		controller.find('select[name=PARAM_DAY]').val(0);
        controller.find('.box').hide();
    }

    function setup() {
        setupControllerEventHandlers();
        var $boxes = controller.find('.boxes');
        controller.setBoxes([
            signUpAccount.create($boxes.find('.box.signup-account'), controller),
            signUpDetail.create($boxes.find('.box.signup-detail'), controller),
            depositBonusBox.create($boxes.find('.box.deposit-bonus'), controller),
            emailVerificationBox.create($boxes.find('.box.email-verification'), controller, 'deposit'),
            mobileVerificationBox.create($boxes.find('.box.mobile-verification'), controller),
            depositBox.create($boxes.find('.box.deposit'), controller),
            depositResultBox.create($boxes.find('.box.deposit-result'), controller)
        ]);

    }



    function updateRegistrationPixelTracking(pixelTrackingData) {
        var $pixelTrackingDiv = controller.find('.pixel-tracking-registration');
        $pixelTrackingDiv.html(pixelTrackingData);
    }

    function getPixelTrackingData() {
        $.post('/pp?flow=GetRegistrationPixelTracking', {}, function (pixelTrackingData) {
            updateRegistrationPixelTracking(pixelTrackingData);
        });
    }

	function nextBox (boxController) {
		if(boxController.boxes[6].model.fromCarousel) {
			//return to carousel
			boxController.currentBoxIndex -= 1;
			boxController.boxes[2].model.chosenBonusId = boxController.boxes[2].model.freeMoneyBonusId;
		}

		controller.nextBox();
	}

    var startSignupClass = {
        createInstance: function (parameters) {
            var signup = {
                start: function () {
                    var controller = start('.signup.controller'),
                        $slidingContentWrapperDiv = controller.$controller.closest('div').parent(),
                        $offerBagde = $('div.offer');

                    $slidingContentWrapperDiv.find('.close').hide();

                    var jqxhr = $.ajax('/pp?flow=LandingPageJson');
                    jqxhr.done(function(data) {
                        $offerBagde.find('img.ui-animation').addClass(data.badgeAnimation);
                        $offerBagde.removeClass('fade-out').addClass('fade-in').show();
                    });
                    return controller;
                },
                args: function () {
                    return undefined;
                }
            };
            return signup;
        },
        dontShowIfAuthenticated: true,
        createHashTag: function() {
            return this.baseHashTag;
        },
        baseHashTag: 'register'
    };

    var signUpController = {};
    signUpController.start = start;
    signUpController.next = nextBox;
    signUpController.startSignupClass = startSignupClass;

    return signUpController;
});

